module.exports = __webpack_public_path__ + "static/media/SC1.2b5cd3cb.jpg";